import { NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, NavParams } from '@ionic/angular';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// import {NgxMaskIonicModule} from 'ngx-mask-ionic'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppInjector } from 'src/app/providers/app-injector.service';
import { AuthInterceptor } from 'src/app/interceptors/http-interceptor';

import { Globals } from 'src/app/providers/globals';
import { AuthProvider } from 'src/app/providers/auth';
import { StorageService } from 'src/app/providers/storage.service';
import { Utils } from 'src/app/helpers/utils';

import { MapService } from 'src/app/providers/map.service';

import { ConsumerBusinessHandlerProvider } from 'src/app/providers/consumer-business-handler';
import { ConsumerBusinessMainHandlerProvider } from 'src/app/providers/consumer-business-main-handler';  
import { ConsumerHandlerProvider } from 'src/app/providers/consumer-handler';
import { ConsumerOrderHandlerProvider } from 'src/app/providers/consumer-order-handler';
import { ConsumerMoneyOrderHandlerProvider } from 'src/app/providers/consumer-money-order-handler';
import { ConsumerServiceBookingHandlerProvider } from 'src/app/providers/consumer-service-booking-handler';

import { ProductPaymentCheckoutHandler } from 'src/app/providers/product-payment-checkout-handler';

import { CardFormatterService } from 'src/app/providers/card-formatter.service';
import { BusinessProductPaymentManagerHandler } from 'src/app/providers/business-product-payment-handler';
import { ChatManagerHandler } from 'src/app/providers/chat-handler';
import { ProductModifierHandler } from 'src/app/providers/product-modifier-handler';
import { PaymentMethodService } from 'src/app/providers/payment-method.service';
import { AddressProvider } from 'src/app/providers/address-handler';
import { PushNotificationHandlerProvider } from 'src/app/providers/push-notification-handler';
import { BusinessMessageProvider } from 'src/app/providers/business-message-handler'
import { ChatMessageManagerHandler } from 'src/app/providers/chat-message-handler';
import { StadiumSeatSelectService } from 'src/app/providers/stadium-seat-select.service';
import { PaymentMethodAgilpayService } from 'src/app/providers/payment-method-agilpay-handler';
import { CacheService } from 'src/app/providers/cache.service';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot({mode: "ios", swipeBackEnabled: false}),
    HttpClientModule,
    AppRoutingModule,
    // NgxMaskIonicModule.forRoot(),

    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
  ],  
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    },

    Globals,
    AuthProvider,           
    Utils,

    MapService,
    
    BusinessProductPaymentManagerHandler,
    ConsumerBusinessHandlerProvider,
    ConsumerHandlerProvider,
    ConsumerBusinessMainHandlerProvider,
    ProductPaymentCheckoutHandler,
    ConsumerOrderHandlerProvider,
    ProductModifierHandler,
    PaymentMethodService,
    AddressProvider,
    PushNotificationHandlerProvider,
    ConsumerMoneyOrderHandlerProvider,
    BusinessMessageProvider,
    StadiumSeatSelectService,
    ConsumerServiceBookingHandlerProvider,

    PaymentMethodAgilpayService,
    CacheService,
    CardFormatterService,
    
    ChatManagerHandler, 
    ChatMessageManagerHandler,    
    NavParams
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.injector = injector;
  }
}
